<script>
  import { _ } from "$helpers/i18n.js";
  import { Accordion } from "$lib";
  import { globalStore } from "../../store/globalStore.js";

  const isMobile = globalStore.isMobile;

  let activeIndex = null;
  let opens = {};

  function toggle(i) {
    if ($isMobile) {
      activeIndex = activeIndex === i ? null : i;
    } else {
      opens = { ...opens, [i]: !opens[i] };
    }
  }
</script>

<div class="explanation-container">
  <Accordion title={$_("explanation.title_1")} open={$isMobile ? activeIndex === 0 : !!opens[0]} onToggle={() => toggle(0)}>
    <div class="explanation-item">
      <p>{$_("cashflowDaily.explanation.paragraph_1")}</p>
      <ol>
        <li>{$_("cashflowDaily.explanation.item_1")}</li>
        <li>{$_("cashflowDaily.explanation.item_2")}</li>
      </ol>
      <p>
        {$_("cashflowDaily.explanation.item_explanation_1")}
        <strong>{$_("common.calculate_bold")}</strong>{$_("cashflowDaily.explanation.item_explanation_2")}
      </p>

      <!-- Formula -->
      <div class="formula">
        <span class="left">{$_("cashflowDaily.explanation.form_left_part")}</span>
        <span class="right">{$_("cashflowDaily.explanation.form_right_part")}</span>
      </div>
  </Accordion>
  <Accordion title={$_("explanation.title_2")} open={$isMobile ? activeIndex === 1 : !!opens[1]} onToggle={() => toggle(1)}>
    <div class="explanation-item">
      <ul class="punteo-list">
        <li>
          {$_("explanation.important_concepts_common_2")}
          <strong>{$_("cashflowDaily.explanation.item_1_concepts_bold")}</strong>
          {$_("cashflowDaily.explanation.item_1_concepts")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_2")}
          <strong>{$_("cashflowDaily.explanation.item_2_concepts_bold")}</strong>
          {$_("cashflowDaily.explanation.item_2_concepts")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_2")}
          <strong>{$_("cashflowDaily.explanation.item_3_concepts_bold_1")}</strong>
          {$_("cashflowDaily.explanation.item_3_concepts_1")}
          <strong>{$_("cashflowDaily.explanation.item_3_concepts_bold_2")}</strong>{$_("cashflowDaily.explanation.item_3_concepts_2")}
        </li>
        <li>
          {$_("cashflowDaily.explanation.item_4_concepts_1")}
          <strong>{$_("cashflowDaily.explanation.item_4_concepts_bold")}</strong>
          {$_("cashflowDaily.explanation.item_4_concepts_2")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_2")}
          <strong>{$_("cashflowDaily.explanation.item_5_concepts_bold")}</strong>
          {$_("cashflowDaily.explanation.item_5_concepts")}
        </li>
      </ul>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_3")} open={$isMobile ? activeIndex === 2 : !!opens[2]} onToggle={() => toggle(2)}>
    <div class="explanation-item">
      <p>{$_("cashflowDaily.explanation.paragraph_2")}</p>
      <ul class="punteo-list">
        <li>{$_("cashflowDaily.explanation.item_1_factors")}</li>
        <li>{$_("cashflowDaily.explanation.item_2_factors")}</li>
        <li>{$_("cashflowDaily.explanation.item_3_factors")}</li>
      </ul>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_8")} open={$isMobile ? activeIndex === 3 : !!opens[3]} onToggle={() => toggle(3)}>
    <div class="explanation-item">
      <ol class="punteo-list">
        <li>
          <strong>{$_("cashflowDaily.explanation.item_1_cases_bold_1")}</strong>
          {$_("cashflowDaily.explanation.item_1_cases_1")}
          <strong>{$_("cashflowDaily.explanation.item_1_cases_bold_2")}</strong>
          {$_("cashflowDaily.explanation.item_1_cases_2")}
        </li>
        <li>
          <strong>{$_("cashflowDaily.explanation.item_2_cases_bold_1")}</strong>
          {$_("cashflowDaily.explanation.item_2_cases_1")}
          <strong>{$_("cashflowDaily.explanation.item_2_cases_bold_2")}</strong>{$_("common.full_stop")}
        </li>
        <li>
          <strong>{$_("cashflowDaily.explanation.item_3_cases_bold_1")}</strong>
          {$_("cashflowDaily.explanation.item_3_cases_1")}
          <strong>{$_("cashflowDaily.explanation.item_3_cases_bold_2")}</strong>
          {$_("cashflowDaily.explanation.item_3_cases_2")}
        </li>
        <li>
          <strong>{$_("cashflowDaily.explanation.item_4_cases_bold_1")}</strong>
          {$_("cashflowDaily.explanation.item_4_cases_1")}
          <strong>{$_("cashflowDaily.explanation.item_4_cases_bold_2")}</strong>
          {$_("cashflowDaily.explanation.item_4_cases_2")}
        </li>
      </ol>
      <p><strong>{$_("cashflowDaily.explanation.paragraph_3_bold")}</strong>
        <br/>
        {$_("cashflowDaily.explanation.paragraph_4")}
        <strong>{$_("cashflowDaily.explanation.paragraph_4_bold")}</strong>
      </p>
      <p>
        <strong>{$_("cashflowDaily.explanation.paragraph_5_bold")}</strong>
        {$_("cashflowDaily.explanation.paragraph_5")}
      </p>
      <ul class="punteo-list">
        <li>
          <strong>{$_("cashflowDaily.explanation.item_5_cases_bold")}</strong>
          {$_("cashflowDaily.explanation.items_5_cases")}
        </li>
        <li>
          <strong>{$_("cashflowDaily.explanation.item_6_cases_bold_1")}</strong>
          {$_("cashflowDaily.explanation.item_6_cases_1")}
          <strong>{$_("cashflowDaily.explanation.item_6_cases_bold_2")}</strong>{$_("cashflowDaily.explanation.item_6_cases_2")}
        </li>
        <li>
          <strong>{$_("cashflowDaily.explanation.item_7_cases_bold_1")}</strong>
          {$_("cashflowDaily.explanation.item_6_cases_1")}
          <strong>{$_("cashflowDaily.explanation.item_7_cases_bold_2")}</strong>{$_("cashflowDaily.explanation.item_7_cases_1")}
        </li>
      </ul>
    </div>
  </Accordion>
</div>
